export default class AppointmentType {
  constructor (data = {}) {
    this.name = data.name || ''
    this.displayName = data.display_name || ''
    this.practiceId = data.pp_practice_id || null
    this.appointmentTypeId = data.appointment_type_id || null
    this.legacyAppointmentTypeId = data.legacy_appointment_type_id || null
    this.createdAt = data.created_at || null
    this.updatedAt = data.updated_at || null
    this.configurations = data.configurations ? data.configurations.map(configuration => new AppointmentTypeConfiguration(configuration)) : []
  }
}

export class AppointmentTypeConfiguration {
  constructor (data = {}) {
    this.appointmentTypeId = data.appointment_type_id || null
    this.scheduleId = data.schedule_id || null
    this.active = data.active || false
    this.patientTypeFilter = data.patient_type_filter || []
    this.visitTypeFilter = data.visit_type_filter || []
    this.attributes = (data.attributes || []).map(attr => new AppointmentTypeConfigurationAttributes(attr))
    this.appointmentTypeConfigurationId = data.appointment_type_configuration_id || null
    this.createdAt = data.created_at || null
    this.updatedAt = data.updated_at || null
  }
}

export class AppointmentTypeConfigurationAttributes {
  constructor (data = {}) {
    this.duration = data.duration || null
    this.feeAmount = data.fee_amount || null
    this.patientType = data.patient_type || null
    this.appointmentTypeConfigurationDurationId = data.appointment_type_configuration_attributes_id || null
    this.appointmentTypeConfigurationId = data.appointment_type_configuration_id || null
    this.createdAt = data.created_at || null
    this.updatedAt = data.updated_at || null
  }
}
